module.exports = __webpack_public_path__ + "static/media/avatar_default.c763b27d.png";